import { render } from "./SettingMemos.vue?vue&type=template&id=5f21afd5"
import script from "./SettingMemos.vue?vue&type=script&lang=js"
export * from "./SettingMemos.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__